import React, { useState, useEffect } from 'react';
import {
  LoadingAlert,
  LoadingHide,
  MessagesFail,
  MessageWarning,
  MessagesSuccess,
  MessageConfirm,
} from '@/pages/manage/common';
import ConferenceSocket from '../conferenceSocket';
import { detail as getDetail } from '@/services/saas/conference';
import './index.scss';

const MemberSort = (members, sortKey, sortDesc) => {
  let newMember = null;
  // 参会名称
  if (sortKey === '0') {
    newMember = members.sort((a, b) => {
      const { name: aN } = a;
      const { name: bN } = b;
      if (sortDesc === '0') {
        return aN.localeCompare(bN, 'zh-CN');
      }
      return bN.localeCompare(aN, 'zh-CN');
    });
  }
  // 呼叫状态
  if (sortKey === '1') {
    // connected === "connected"
    newMember = members.sort((a, b) => {
      const aC = a.connected === 'connected';
      const bC = b.connected === 'connected';
      if (sortDesc === '0') {
        return bC - aC;
      }
      return aC - bC;
    });
  }
  const mainIndex = newMember.findIndex((item) => item.lecturer);
  if (mainIndex > -1) {
    const temp = { ...newMember[mainIndex] };
    newMember.splice(mainIndex, 1);
    newMember.unshift(temp);
  }
  return newMember;
};

const ManageContainer = (props) => {
  const { id, children } = props;


  const [detail, setDetail] = useState({});

  const [duration, setDuration] = useState(undefined);

  // const [ recordTime, setRecordTime ] = useState('00:00:00');

  const [members, setMembers] = useState([]);

  const [speaks, setSpeaks] = useState([]);

  const [buttons, setButtons] = useState({});

  const [socket, setSocket] = useState({});

  const [status, setStatus] = useState({
    conferenceStatus: undefined,
    startTime: undefined,
    endTime: undefined,
    duration: undefined,
  });

  const initSocket = ({ id, roomId }) => {
    const socket = new ConferenceSocket({ id, roomId });
    socket.onComplete = () => {
      socket.setSyncStatus();
      LoadingHide();
    };
    socket.onBefore = () => {
      LoadingAlert('连接中...');
    };
    socket.onFailback = () => {
      MessagesFail(`重连失败,请联系管理员`);
      LoadingHide();
    };
    socket.onConferenceStart = () => {
      LoadingHide();
      setStatus((pre) => ({ ...pre, conferenceStatus: '1' }));
    };
    socket.onConferenceEnd = () => {
      if (socket.banBack) return;
      LoadingHide();
      MessagesSuccess('课程已结束, 即将返回', () => {
        window.history.go(-1);
      });
      setDuration(-1);
      setStatus((pre) => ({ ...pre, conferenceStatus: '2' }));
      if (typeof window.ext3bu != 'undefined' && null != window.ext3bu) {
        window.ext3bu.closePltClass();
      }
    };
    socket.onConferenceUpdate = ({ startTime, endTime, duration }) => {
      setDuration(duration);
      setStatus((pre) => ({
        ...pre,
        startTime,
        endTime,
        duration,
      }));
    };
    socket.onPlatLive = ({ platLive }) => {
      setButtons((preObj) => ({ ...preObj, platLive }));
    };
    socket.onPlatRecord = ({ platRecord }) => {
      setButtons((preObj) => ({ ...preObj, platRecord }));
    };
    socket.onLocalRecord = ({ localRecord }) => {
      setButtons((preObj) => ({ ...preObj, localRecord }));
    };
    socket.onTarget = ({ target }) => {
      setButtons((preObj) => ({ ...preObj, target }));
    };
    socket.onAutoSpeak = ({ autoSpeak }) => {
      setButtons((preObj) => ({ ...preObj, autoSpeak }));
    };
    socket.onTrackMode = ({ trackMode }) => {
      setButtons((preObj) => ({ ...preObj, trackMode }));
    };
    socket.onDoubleContent = ({ doubleContent }) => {
      setButtons((preObj) => ({ ...preObj, doubleContent }));
    };
    socket.onSplitScreen = ({ policyCode, pipPos }) => {
      const layoutMode = { policyCode, pipPos };
      setButtons((preObj) => ({ ...preObj, layoutMode }));
    };
    socket.onMemberUpdate = ({ roomId, name, connected, audioMute, speaking, lecturer }) => {
      const obj = { roomId, name, connected, audioMute, speaking, lecturer };
      setMembers((preMember) => {
        let newMember = [...preMember];
        let theIndex = -1;
        preMember.forEach((item, index) => {
          if (item.roomId === roomId) {
            theIndex = index;
          }
        });
        if (theIndex > -1) {
          newMember[theIndex] = obj;
        } else {
          newMember.push(obj);
        }
        const mainIndex = newMember.findIndex((item) => item.lecturer);
        if (mainIndex > -1) {
          const temp = { ...newMember[mainIndex] };
          newMember.splice(mainIndex, 1);
          newMember.unshift(temp);
        }
        return MemberSort(newMember, '1', '0');
      });
    };

    socket.onMemberSpeaks = ({ roomId, name, speaking, connected }) => {
      const obj = { roomId, name, speaking, connected };
      setSpeaks((preSpeaks) => {
        let newSpeak = [...preSpeaks];
        let theIndex = -1;
        preSpeaks.forEach((item, index) => {
          if (item.roomId === roomId) {
            theIndex = index;
          }
        });
        if (theIndex > -1) {
          newSpeak[theIndex] = obj;
        } else {
          newSpeak.push(obj);
        }
        newSpeak = newSpeak.filter((item) => item.speaking === '1');
        return newSpeak;
      });
    };
    socket.onMemberDelete = ({ roomId }) => {
      setMembers([...members.filter((item) => item.roomId !== roomId)]);
      setSpeaks([...speaks.filter((item) => item.roomId !== roomId)]);
    };
    socket.errorMsg = (msg) => {
      MessageWarning(msg);
    };
    socket.warning = ({ message }) => {
      MessageWarning(message);
    };
    setSocket(socket);

    return socket;
  };

  const setDefualt = async () => {
    // 获取基本数据
    const resp = await getDetail({ id });
    if (resp && resp.success) {
      const { typeCode } = resp.data;
      setDetail(resp.data);
      startTeachApp(typeCode);
      initSocket({ id, roomId: resp.data.memberId }).startSocket();
    }
  };

  const startTeachApp = async (lessonCode) => {
    const ext3bu = window.ext3bu;
    if (typeof ext3bu != 'undefined' && null != ext3bu) {
      document.body.style.background = 'transparent';
      document.querySelector('.app').style.background = 'transparent';
      document.querySelector('.app-router').style.background = 'transparent';
      if (!ext3bu.isReady4SaaSLesson(lessonCode)) {
        try {
          await MessageConfirm('是否需要启动教学应用？');
          ext3bu.prepareSaaSLesson(lessonCode);
          if (lessonCode === '2') {
            //精品课设置预览
            ext3bu.setPreviewPath('/live/main');
          }
          // $("#app_start_modal").addClass("active");
          var time = 30;
          var inter = setInterval(function () {
            time--;
            if (time >= 0) {
              // $("#app_start_modal .signal-communication-ip").text("倒计时"+time+"秒");
              if (time % 5 === 0) {
                if (ext3bu.isReady4SaaSLesson(lessonCode)) {
                  clearInterval(inter);
                  MessagesSuccess('教学应用启动成功');
                } else if (time <= 0) {
                  clearInterval(inter);
                  MessagesSuccess('教学应用启动失败');
                }
              }
            }
          }, 1000);
        } catch (e) {
          if (lessonCode === '2') {
            //精品课设置预览
            ext3bu.setPreviewPath('/live/main');
          }
        }
      } else {
        if (lessonCode === '2') {
          //精品课设置预览
          ext3bu.setPreviewPath('/live/main');
        }
      }
    }
  };

  useEffect(() => {
    setDefualt();
    return function () {
      document.body.style.background = null;
      document.querySelector('.app').style.background = null;
      document.querySelector('.app-router').style.background = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const newProps = {
    ...props,
    detail,
    buttons,
    socket,
    members,
    speaks,
    status: {
      ...status,
      duration,
      memberNumber: members.length,
      onlineNumber: members.filter((item) => item.connected === 'connected').length,
    },
  };

  return <>{children(newProps)}</>;
};

export default ManageContainer;
